export const addItems = ({ items, global }) => ({
  type: 'ITEMS',
  items,
  global
})

export const addFilter = filter => ({
  type: 'FILTER',
  filter
})

export const activeButton = name => ({
  type: 'ACTIVE_BUTTON',
  name
})

export const activeId = id => ({
  type: 'ACTIVE_ID',
  id
})